module.exports = __webpack_public_path__ + "media/images/smart_phone/login/202001/dl_app-528a03e8b914546b2312ec755ddea5d7.png";